import { useNavigate } from "react-router-dom";
import { ChangePasswordCard } from "./AdminChangePassword";
import { useAdminAuth } from "../../context/AdminAuthProvider";
import {
    AdminPageHeader,
    SectionCard,
} from "../../components/admin/FormPrimitives";
import { LogOut } from "lucide-react";

export default function AdminAccount() {
    const { admin, logout } = useAdminAuth();
    const nav = useNavigate();
    return (
        <div data-testid="admin-account-page">
            <AdminPageHeader
                title="Compte"
                subtitle={
                    admin?.email ? `Connecté en tant que ${admin.email}.` : ""
                }
            />
            <SectionCard title="Session" testId="account-session-card">
                <p className="text-sm text-neutral-400 mb-5">
                    Déconnectez-vous quand vous quittez le poste. Votre jeton
                    d'accès est stocké localement dans ce navigateur uniquement.
                </p>
                <button
                    type="button"
                    onClick={() => {
                        logout();
                        nav("/admin/login", { replace: true });
                    }}
                    data-testid="admin-account-logout"
                    className="btn-outline-gold"
                >
                    <LogOut size={14} /> Déconnexion
                </button>
            </SectionCard>
            <div className="mt-6">
                <ChangePasswordCard compact />
            </div>
        </div>
    );
}
